// extracted by mini-css-extract-plugin
export default {"tabsWrapper":"styles_tabsWrapper__3zcl-"};